import uniqueId from 'lodash/uniqueId';
import React from 'react';

import Draggable from 'components/Draggable/Draggable';
import { MediaCMS } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './JoinUsGallerySection.styles';

export interface JoinUsGallerySectionProps {
  sectionTitle: string;
  dragIndicatorLabel: string;
  images: Array<{ image: MediaCMS }>;
}

const defaultProps: Partial<JoinUsGallerySectionProps> = {};

const JoinUsGallerySection: React.FunctionComponent<
  JoinUsGallerySectionProps
> = ({ images }) => (
  <S.JoinUsGallerySectionWrapper>
    <Draggable>
      <S.ImagesWrapper>
        {images.map(({ image }) => (
          <S.Image key={image.url + uniqueId()} src={image.url} />
        ))}
      </S.ImagesWrapper>
    </Draggable>
  </S.JoinUsGallerySectionWrapper>
);

JoinUsGallerySection.defaultProps = defaultProps;

export default JoinUsGallerySection;
